<template>
    <div>
        <div ref="chart" :style="{width: '100%', height: '500px'}"></div>
    </div>
</template>

<script>
    import echart from 'echarts'
    import Moment from "moment";

    export default {
        name: "echart",
        props: {
            name: {
                type: String,
                default: "SSR/RFP"
            },
            eventActualDate:Array,
            scheduleList: Array,
            show: Boolean,
            createDate: {
                type: Date,
                default: new Date()
            }
        },
        computed: {
            option() {
                let option = {
                    title: {
                        show: true,
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {
                                name: this.name,
                                show: true,
                                title: " "
                            }
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        },
                        formatter: function (params) {
                            return `${(Moment(params[0].data)).format("YYYY-MM-DD")+"~~："+(Moment(params[1].data)).format("YYYY-MM-DD")}`;
                        }
                    },
                    legend:  {
                        data: []
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        top: "30",
                        containLabel: true
                    },
                    yAxis: {
                        data: [],
                        inverse:true,
                    },
                    xAxis: {
                        type: 'time',
                        position: "top"
                    },
                    series: [
                        {
                            name: '计划开始时间',
                            type: 'bar',
                            barWidth:'10px',
                            stack: 'startDate1',
                            itemStyle: {
                                barBorderColor: 'white',
                                color: 'white'
                            },
                            zlevel: -1,
                            z: 3,
                            label: {
                                show: true,
                                position: 'inside',
                            },
                        },
                        {
                            name: '计划结束时间',
                            type: 'bar',
                            stack: 'startDate1',
                            barWidth:'10px',
                            label: {
                                show: true,
                                position: 'inside',
                            },
                            itemStyle: {
                                color:"#f8ab01"
                            },
                            zlevel: -1,
                        },
                    ]
                };
                let startDates = [];
                let endDates = [];
                this.scheduleList.forEach((schedule,index) => {
                    startDates.push(schedule.startDate);
                    endDates.push(schedule.deadline);
                    option.legend.data.push(schedule.projectItem);
                    option.yAxis.data.push(schedule.projectItem);
                })
                option.series[0].data = startDates;
                option.series[1].data = endDates;
                let yellow = "#E6A23C";
                let green = "#67C23A";
                let red = "#FB4E4E";
                // option.series[1].data.forEach((date,index)=>{
                //     let plantDate = option.series[2].data[index];
                //     let actualDate = option.series[2].data[index];
                //     let overDays = Moment(actualDate).diff(Moment(plantDate), 'days');
                //     if (overDays > 14) {
                //         option.series[3].itemStyle = {color: red};
                //     } else if (overDays > 0) {
                //         option.series[3].itemStyle = {color: yellow};
                //     } else if (overDays <= 0) {
                //         option.series[3].itemStyle = {color: green};
                //     }
                // })
                console.log(option);
                return option;
            }
        },
        data: () => {
            return {
                chart: null
            }
        },
        mounted() {
            this.chart = echart.init(this.$refs.chart);
            this.chart.setOption(this.option);
        },
        watch: {
            show(value) {
                if (value) {
                    this.chart.setOption(this.option);
                }
            }
        }
    }
</script>

<style scoped>

</style>
